const EM_BASE_URL = require('../../constants').BASE_URL;

module.exports = {
  BASE_URL: `${EM_BASE_URL}/_modules/em-form-controls`
};